// Formatos de pantalla comunes del módulo Inversiones exterior

// Estado de una carga, como se muestra
export const ESTADOS_CARGA = {
    procesando: 'Procesando',
    por_revisar: 'Por revisar',
    validada: 'Validada',
    error: 'Con error'
};

// Fecha y hora de Chile, como «14-10-26 11:25»
export const formatearFechaHora = (iso) =>
    new Date(iso).toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short', timeZone: 'America/Santiago' });

// Dígitos de un monto, con el signo menos solo al comienzo
export const soloDigitos = (texto) => String(texto).replace(/[^\d-]/g, '').replace(/(?!^)-/g, '');

// Monto en pesos con separador de miles, como «3.095.980». Lo que se está
// escribiendo («» o «-») queda igual.
export const conMiles = (digitos) => {
    const texto = String(digitos);
    return texto === '' || texto === '-' ? texto : Number(texto).toLocaleString('es-CL');
};

// Monto en otra moneda, guardado con punto decimal, en pantalla con miles y coma:
// «3400.12» → «3.400,12». Lo que se está escribiendo («3400.» → «3.400,») queda igual.
export const conMilesYDecimales = (valor) => {
    const [entero, decimales] = String(valor ?? '').split('.');
    return decimales === undefined ? conMiles(entero) : `${conMiles(entero)},${decimales}`;
};
